import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import AdminProtectedRoute from './components/Auth/AdminProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Analyses from './pages/Analyses';
import Accounts from './pages/Accounts';
import AccountDetails from './pages/AccountDetails';
import TokenUsage from './pages/TokenUsage';
import Transactions from './pages/Transactions';
import FailedEvents from './pages/FailedEvents';
import Telemetry from './pages/Telemetry';
import FeatureFlags from './pages/FeatureFlags';
import Notifications from './pages/Notifications';

function App() {
  return (
    <AdminAuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'bg-gray-800 text-white border border-gray-700',
          style: {
            background: '#1f2937',
            color: '#fff',
            border: '1px solid #374151',
          },
        }}
      />
      <Routes>
        {/* Public routes */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/auth/google/callback" element={<AuthCallback />} />

        {/* Redirect root to admin dashboard */}
        <Route path="/" element={<Navigate to="/admin/dashboard" />} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />

        {/* Protected routes */}
        <Route
          element={
            <AdminProtectedRoute>
              <AdminLayout />
            </AdminProtectedRoute>
          }
        >
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/users" element={<Users />} />
          <Route path="/admin/analyses" element={<Analyses />} />
          <Route path="/admin/accounts" element={<Accounts />} />
          <Route path="/admin/accounts/:id" element={<AccountDetails />} />
          <Route path="/admin/token-usage" element={<TokenUsage />} />
          <Route path="/admin/transactions" element={<Transactions />} />
          <Route path="/admin/failed-events" element={<FailedEvents />} />
          <Route path="/admin/feature-flags" element={<FeatureFlags />} />
          <Route path="/admin/notifications" element={<Notifications />} />
          <Route path="/admin/telemetry/:id" element={<Telemetry />} />
        </Route>

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/admin/dashboard" />} />
      </Routes>
    </AdminAuthProvider>
  );
}

export default App;
